import React from 'react';
import { useTranslation } from 'react-i18next';
import './ImproveWithAiButton.scss';
import { ReactComponent as AIIcon } from '../../../../assets/icons/u_AI.svg';
import { IASuggestionResponse } from '../../../../api/accordanceApi';
import { IAImproveText } from '../../../ProjectDetail/ProjectTabs/Accordances/NewAccordanceForm/IAImproveText/IAImproveText';

type Props = {
  disabled?: boolean;
  handleClick: () => void;
  customText?: string;
  isLoading?: boolean;
  IAResponse?: IASuggestionResponse | null;
  IAErrorRequest?: string | null;
  suggestedText?: string;
  onUse: () => void;
  onDiscard: () => void;
  onRetry: () => void;
  onCancel: () => void;
};

const ImproveWithAIButton = ({
  disabled,
  handleClick,
  customText,
  isLoading,
  IAResponse,
  IAErrorRequest,
  suggestedText,
  onUse,
  onDiscard,
  onRetry,
  onCancel }: Props) => {
  const { t } = useTranslation();

  return IAResponse ? (
    <IAImproveText
      suggestedText={suggestedText}
      onUse={onUse}
      onDiscard={onDiscard}
    />
  ) : IAErrorRequest ? (
    <div>
      <div className="improve-with-ai-button__error">{IAErrorRequest}</div>
      <section className="flex">
        <button
          className={`btn btn-primary small`}
          disabled={disabled}
          onClick={onRetry}
          type="button"
        >{t('retry_message')}</button>
        <button
          className={`btn btn-primary-outlined small`}
          disabled={disabled}
          onClick={onCancel}
          type="button"
        >{t('cancel')}</button>
      </section>
    </div>
  ) : (
    <div className='content-review-wording'>
      <p>{t('ai_can_adjust_wording')}</p>

      <button
        className={`improve-with-ai-button ${disabled ? 'disabled' : isLoading ? 'loading' : 'active'}`}
        disabled={disabled}
        onClick={handleClick}
        type="button"
      >
        {isLoading ? <span className="loading-spinner"></span> : <AIIcon className="improve-with-ai-button__icon" />}
        <p className={"improve-with-ai-button__text" + (isLoading ? " loading" : "")}>{customText || t('review_wording').toUpperCase()}</p>
      </button>
    </div>

  );
};

export default ImproveWithAIButton;
